import { PagesUrl } from 'core/Utils';
import { NavLink } from 'react-router-dom';
import { ActionIcon, Divider, Menu } from 'ui';
import { useDisclosure } from 'ui/Hooks';
import { IconHambMenu } from 'ui/Icons';

import LogoutConfirmation from '../../../../modals/logoutConfirmation/LogoutConfirmation';
import classes from './DesktopHamburgerMenu.module.css';

const DesktopHamburgerMenu = () => {
  const [isLogoutOpened, logoutHandlers] = useDisclosure(false);

  return (
    <>
      <Menu position="bottom-end">
        <Menu.Target>
          <ActionIcon size="md" variant="gray">
            <IconHambMenu />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown w={'140px'}>
          <Menu.Item component={NavLink} to={PagesUrl.PROFILE}>
            Profile
          </Menu.Item>
          <Menu.Item component={NavLink} to={'settings'}>
            Settings
          </Menu.Item>
          <Menu.Item component={'a'} href={'https://www.givebacks.com/faq'} target="_blank">
            FAQ
          </Menu.Item>
          <Menu.Item component={'a'} href={'https://www.givebacks.com/terms'} target="_blank">
            Legal
          </Menu.Item>
          <Menu.Item
            component={'a'}
            href={
              'https://support.givebacks.com/hc/en-us/categories/24997887276439-The-Givebacks-App'
            }
            target="_blank"
          >
            Support
          </Menu.Item>

          <Divider mx="sm" />
          <Menu.Item className={classes.removeFirstTopRadius} onClick={logoutHandlers.open}>
            Log Out
          </Menu.Item>
        </Menu.Dropdown>
        <LogoutConfirmation visibility={isLogoutOpened} handleClose={logoutHandlers.close} />
      </Menu>
    </>
  );
};

export { DesktopHamburgerMenu };
